function V(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Y = Object.getOwnPropertySymbols, U = Object.prototype.hasOwnProperty, J = Object.prototype.propertyIsEnumerable;
function K(i) {
  if (i == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(i);
}
function Z() {
  try {
    if (!Object.assign)
      return !1;
    var i = new String("abc");
    if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
      return !1;
    for (var r = {}, e = 0; e < 10; e++)
      r["_" + String.fromCharCode(e)] = e;
    var o = Object.getOwnPropertyNames(r).map(function(a) {
      return r[a];
    });
    if (o.join("") !== "0123456789")
      return !1;
    var t = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(a) {
      t[a] = a;
    }), Object.keys(Object.assign({}, t)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var _ = Z() ? Object.assign : function(i, r) {
  for (var e, o = K(i), t, a = 1; a < arguments.length; a++) {
    e = Object(arguments[a]);
    for (var n in e)
      U.call(e, n) && (o[n] = e[n]);
    if (Y) {
      t = Y(e);
      for (var s = 0; s < t.length; s++)
        J.call(e, t[s]) && (o[t[s]] = e[t[s]]);
    }
  }
  return o;
};
const S = /* @__PURE__ */ V(_);
var E = function(r, e) {
  var o = S({}, r, e);
  for (var t in r) {
    var a;
    !r[t] || typeof e[t] != "object" || S(o, (a = {}, a[t] = S(r[t], e[t]), a));
  }
  return o;
}, rr = function(r) {
  var e = {};
  return Object.keys(r).sort(function(o, t) {
    return o.localeCompare(t, void 0, {
      numeric: !0,
      sensitivity: "base"
    });
  }).forEach(function(o) {
    e[o] = r[o];
  }), e;
}, er = {
  breakpoints: [40, 52, 64].map(function(i) {
    return i + "em";
  })
}, k = function(r) {
  return "@media screen and (min-width: " + r + ")";
}, tr = function(r, e) {
  return C(e, r, r);
}, C = function(r, e, o, t, a) {
  for (e = e && e.split ? e.split(".") : [e], t = 0; t < e.length; t++)
    r = r ? r[e[t]] : a;
  return r === a ? o : r;
}, P = function i(r) {
  var e = {}, o = function(n) {
    var s = {}, c = !1, p = n.theme && n.theme.disableStyledSystemCache;
    for (var g in n)
      if (r[g]) {
        var l = r[g], f = n[g], v = C(n.theme, l.scale, l.defaults);
        if (typeof f == "object") {
          if (e.breakpoints = !p && e.breakpoints || C(n.theme, "breakpoints", er.breakpoints), Array.isArray(f)) {
            e.media = !p && e.media || [null].concat(e.breakpoints.map(k)), s = E(s, or(e.media, l, v, f, n));
            continue;
          }
          f !== null && (s = E(s, ar(e.breakpoints, l, v, f, n)), c = !0);
          continue;
        }
        S(s, l(f, v, n));
      }
    return c && (s = rr(s)), s;
  };
  o.config = r, o.propNames = Object.keys(r), o.cache = e;
  var t = Object.keys(r).filter(function(a) {
    return a !== "config";
  });
  return t.length > 1 && t.forEach(function(a) {
    var n;
    o[a] = i((n = {}, n[a] = r[a], n));
  }), o;
}, or = function(r, e, o, t, a) {
  var n = {};
  return t.slice(0, r.length).forEach(function(s, c) {
    var p = r[c], g = e(s, o, a);
    if (!p)
      S(n, g);
    else {
      var l;
      S(n, (l = {}, l[p] = S({}, n[p], g), l));
    }
  }), n;
}, ar = function(r, e, o, t, a) {
  var n = {};
  for (var s in t) {
    var c = r[s], p = t[s], g = e(p, o, a);
    if (!c)
      S(n, g);
    else {
      var l, f = k(c);
      S(n, (l = {}, l[f] = S({}, n[f], g), l));
    }
  }
  return n;
}, F = function(r) {
  var e = r.properties, o = r.property, t = r.scale, a = r.transform, n = a === void 0 ? tr : a, s = r.defaultScale;
  e = e || [o];
  var c = function(g, l, f) {
    var v = {}, B = n(g, l, f);
    if (B !== null)
      return e.forEach(function(z) {
        v[z] = B;
      }), v;
  };
  return c.scale = t, c.defaults = s, c;
}, R = function(r) {
  r === void 0 && (r = {});
  var e = {};
  Object.keys(r).forEach(function(t) {
    var a = r[t];
    if (a === !0) {
      e[t] = F({
        property: t,
        scale: t
      });
      return;
    }
    if (typeof a == "function") {
      e[t] = a;
      return;
    }
    e[t] = F(a);
  });
  var o = P(e);
  return o;
}, q = function() {
  for (var r = {}, e = arguments.length, o = new Array(e), t = 0; t < e; t++)
    o[t] = arguments[t];
  o.forEach(function(n) {
    !n || !n.config || S(r, n.config);
  });
  var a = P(r);
  return a;
}, ir = function(r) {
  return typeof r == "number" && !isNaN(r);
}, nr = function(r, e) {
  return C(e, r, !ir(r) || r > 1 ? r : r * 100 + "%");
}, sr = {
  width: {
    property: "width",
    scale: "sizes",
    transform: nr
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  size: {
    properties: ["width", "height"],
    scale: "sizes"
  },
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  display: !0,
  verticalAlign: !0
}, h = R(sr), N = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: !0
};
N.bg = N.backgroundColor;
var Q = R(N), dr = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
}, pr = {
  fontFamily: {
    property: "fontFamily",
    scale: "fonts"
  },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: dr.fontSizes
  },
  fontWeight: {
    property: "fontWeight",
    scale: "fontWeights"
  },
  lineHeight: {
    property: "lineHeight",
    scale: "lineHeights"
  },
  letterSpacing: {
    property: "letterSpacing",
    scale: "letterSpacings"
  },
  textAlign: !0,
  fontStyle: !0
}, x = R(pr), cr = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: !0,
  // item
  flex: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: !0,
  justifySelf: !0,
  alignSelf: !0,
  order: !0
}, b = R(cr), I = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
}, lr = {
  gridGap: {
    property: "gridGap",
    scale: "space",
    defaultScale: I.space
  },
  gridColumnGap: {
    property: "gridColumnGap",
    scale: "space",
    defaultScale: I.space
  },
  gridRowGap: {
    property: "gridRowGap",
    scale: "space",
    defaultScale: I.space
  },
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridAutoRows: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, y = R(lr), u = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  }
};
u.borderTopWidth = {
  property: "borderTopWidth",
  scale: "borderWidths"
};
u.borderTopColor = {
  property: "borderTopColor",
  scale: "colors"
};
u.borderTopStyle = {
  property: "borderTopStyle",
  scale: "borderStyles"
};
u.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
};
u.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
};
u.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
};
u.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
};
u.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
};
u.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
};
u.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
};
u.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
};
u.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
};
u.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
};
u.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
};
u.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
};
u.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var W = R(u), w = {
  background: !0,
  backgroundImage: !0,
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0
};
w.bgImage = w.backgroundImage;
w.bgSize = w.backgroundSize;
w.bgPosition = w.backgroundPosition;
w.bgRepeat = w.backgroundRepeat;
var $ = R(w), A = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
}, gr = {
  position: !0,
  zIndex: {
    property: "zIndex",
    scale: "zIndices"
  },
  top: {
    property: "top",
    scale: "space",
    defaultScale: A.space
  },
  right: {
    property: "right",
    scale: "space",
    defaultScale: A.space
  },
  bottom: {
    property: "bottom",
    scale: "space",
    defaultScale: A.space
  },
  left: {
    property: "left",
    scale: "space",
    defaultScale: A.space
  }
}, O = R(gr), m = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
}, M = function(r) {
  return typeof r == "number" && !isNaN(r);
}, L = function(r, e) {
  if (!M(r))
    return C(e, r, r);
  var o = r < 0, t = Math.abs(r), a = C(e, t, t);
  return M(a) ? a * (o ? -1 : 1) : o ? "-" + a : a;
}, d = {};
d.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: L,
    defaultScale: m.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: L,
    defaultScale: m.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: L,
    defaultScale: m.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: L,
    defaultScale: m.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: L,
    defaultScale: m.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: L,
    defaultScale: m.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: L,
    defaultScale: m.space
  }
};
d.margin.m = d.margin.margin;
d.margin.mt = d.margin.marginTop;
d.margin.mr = d.margin.marginRight;
d.margin.mb = d.margin.marginBottom;
d.margin.ml = d.margin.marginLeft;
d.margin.mx = d.margin.marginX;
d.margin.my = d.margin.marginY;
d.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: m.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: m.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: m.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: m.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: m.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: m.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: m.space
  }
};
d.padding.p = d.padding.padding;
d.padding.pt = d.padding.paddingTop;
d.padding.pr = d.padding.paddingRight;
d.padding.pb = d.padding.paddingBottom;
d.padding.pl = d.padding.paddingLeft;
d.padding.px = d.padding.paddingX;
d.padding.py = d.padding.paddingY;
var ur = R(d.margin), fr = R(d.padding), mr = q(ur, fr);
R({
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  }
});
function j() {
  return j = Object.assign || function(i) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var o in e)
        Object.prototype.hasOwnProperty.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }, j.apply(this, arguments);
}
var T = function(r, e, o, t, a) {
  for (e = e && e.split ? e.split(".") : [e], t = 0; t < e.length; t++)
    r = r ? r[e[t]] : a;
  return r === a ? o : r;
}, br = [40, 52, 64].map(function(i) {
  return i + "em";
}), hr = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
}, vr = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
}, D = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
}, yr = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
}, Sr = function(r, e) {
  if (typeof e != "number" || e >= 0)
    return T(r, e, e);
  var o = Math.abs(e), t = T(r, o, o);
  return typeof t == "string" ? "-" + t : t * -1;
}, Rr = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(i, r) {
  var e;
  return j({}, i, (e = {}, e[r] = Sr, e));
}, {}), Tr = function(r) {
  return function(e) {
    var o = {}, t = T(e, "breakpoints", br), a = [null].concat(t.map(function(g) {
      return "@media screen and (min-width: " + g + ")";
    }));
    for (var n in r) {
      var s = typeof r[n] == "function" ? r[n](e) : r[n];
      if (s != null) {
        if (!Array.isArray(s)) {
          o[n] = s;
          continue;
        }
        for (var c = 0; c < s.slice(0, a.length).length; c++) {
          var p = a[c];
          if (!p) {
            o[n] = s[c];
            continue;
          }
          o[p] = o[p] || {}, s[c] != null && (o[p][n] = s[c]);
        }
      }
    }
    return o;
  };
}, wr = function i(r) {
  return function(e) {
    e === void 0 && (e = {});
    var o = j({}, hr, {}, e.theme || e), t = {}, a = typeof r == "function" ? r(o) : r, n = Tr(a)(o);
    for (var s in n) {
      var c = n[s], p = typeof c == "function" ? c(o) : c;
      if (s === "variant") {
        var g = i(T(o, p))(o);
        t = j({}, t, {}, g);
        continue;
      }
      if (p && typeof p == "object") {
        t[s] = i(p)(o);
        continue;
      }
      var l = T(vr, s, s), f = T(yr, l), v = T(o, f, T(o, l, {})), B = T(Rr, l, T), z = B(v, p, p);
      if (D[l])
        for (var X = D[l], G = 0; G < X.length; G++)
          t[X[G]] = z;
      else
        t[l] = z;
    }
    return t;
  };
};
const Wr = wr;
var H = function(r) {
  var e, o = r.scale, t = r.prop, a = t === void 0 ? "variant" : t, n = r.variants, s = n === void 0 ? {} : n, c = r.key, p;
  Object.keys(s).length ? p = function(v, B, z) {
    return Wr(C(B, v, null))(z.theme);
  } : p = function(v, B) {
    return C(B, v, null);
  }, p.scale = o || c, p.defaults = s;
  var g = (e = {}, e[a] = p, e), l = P(g);
  return l;
};
H({
  key: "buttons"
});
H({
  key: "textStyles",
  prop: "textStyle"
});
H({
  key: "colorStyles",
  prop: "colors"
});
h.width;
h.height;
h.minWidth;
h.minHeight;
h.maxWidth;
h.maxHeight;
h.size;
h.verticalAlign;
h.display;
h.overflow;
h.overflowX;
h.overflowY;
Q.opacity;
x.fontSize;
x.fontFamily;
x.fontWeight;
x.lineHeight;
x.textAlign;
x.fontStyle;
x.letterSpacing;
b.alignItems;
b.alignContent;
b.justifyItems;
b.justifyContent;
b.flexWrap;
b.flexDirection;
b.flex;
b.flexGrow;
b.flexShrink;
b.flexBasis;
b.justifySelf;
b.alignSelf;
b.order;
y.gridGap;
y.gridColumnGap;
y.gridRowGap;
y.gridColumn;
y.gridRow;
y.gridAutoFlow;
y.gridAutoColumns;
y.gridAutoRows;
y.gridTemplateColumns;
y.gridTemplateRows;
y.gridTemplateAreas;
y.gridArea;
W.borderWidth;
W.borderStyle;
W.borderColor;
W.borderTop;
W.borderRight;
W.borderBottom;
W.borderLeft;
W.borderRadius;
$.backgroundImage;
$.backgroundSize;
$.backgroundPosition;
$.backgroundRepeat;
O.zIndex;
O.top;
O.right;
O.bottom;
O.left;
const Br = () => q(h, O, mr, Q, b, x, W);
export {
  y as a,
  W as b,
  Br as c,
  V as g,
  _ as o
};
